import { Getter } from "vuex";
import { IState } from './state';

const links: Getter<IState, IState> = (state) => {
	return state.props.sort === 'alphabetical' ? 
		[...state.props.links].sort((a:any, b:any) => {
			return a.title.localeCompare(b.title, 'sv')
		}) :
		state.props.links
}
const isListView: Getter<IState, IState> = (state) => state.props.isListView;
const showTags: Getter<IState, IState> = (state) => state.props.showTags;
const boxFullHeight: Getter<IState, IState> = (state) => state.props.boxFullHeight;
const showImage: Getter<IState, IState> = (state) => state.props.showImage;
const listType: Getter<IState, IState> = (state) => state.props.listType;
const showIngress: Getter<IState, IState> = (state) => state.props.showIngress;

export default {
	links,
	isListView,
	showTags,
	showImage,
	boxFullHeight,
	listType,
	showIngress
}